/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of the component
 */
export type InventoryComponentType = 'UNKNOWN' | 'IRR' | 'CDVX' | 'DRC' | 'SITE' | 'VCENTER' | 'SRM' | 'VPC';

export const InventoryComponentType = {

    UNKNOWN: 'UNKNOWN' as InventoryComponentType,

    IRR: 'IRR' as InventoryComponentType,

    CDVX: 'CDVX' as InventoryComponentType,

    DRC: 'DRC' as InventoryComponentType,

    SITE: 'SITE' as InventoryComponentType,

    VCENTER: 'VCENTER' as InventoryComponentType,

    SRM: 'SRM' as InventoryComponentType,

    VPC: 'VPC' as InventoryComponentType
};

